module.exports = __webpack_public_path__ + "img/knu_gallery13.b3d17167.jpg";